export default __webpack_public_path__ + "static/media/Calendar.72a3b31d.svg";